import { render, staticRenderFns } from "./OrderScrap.vue?vue&type=template&id=466d60a1&scoped=true"
import script from "./OrderScrap.vue?vue&type=script&lang=js"
export * from "./OrderScrap.vue?vue&type=script&lang=js"
import style0 from "./OrderScrap.vue?vue&type=style&index=0&id=466d60a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466d60a1",
  null
  
)

export default component.exports